<template>
  <div
    v-if="showChrome"
    class="app-chrome"
  >
    <WHeader />
    <WSystemStatusBar />
  </div>
  <PScrollTop size="small" />

  <div class="app-content my-2 pt-1">
    <RouterView class="text-sm" />
  </div>

  <!-- Global Toast element -->
  <PToast :position="toastPosition" />

  <!-- ************************************************************ Common system message dialog -->
  <!-- <message-dialog
    v-if="showMessageDialog"
    :message="message"
    @[CONSTANTS.EVENTS.CLOSED]="showMessageDialog = false"
	/>-->

  <!-- ************************************************************ Global loading overlay -->
  <!-- <v-overlay
    v-model="loadingControls.show"
    :persistent="true"
    :close-on-back="false"
    :close-on-content-click="false"
    :eager="true"
    :no-click-animation="true"
    scrim="white"
    class="d-flex justify-center align-center"
  >
    <v-progress-circular
      :model-value="loadingControls.value"
      :indeterminate="loadingControls.indeterminate"
      size="160"
      width="7"
      color="primary"
    >
      <div class="text-center">
        <div><b>loading</b></div>
        <div v-if="!loadingControls.indeterminate"><b>{{ loadingControls.value }} %</b></div>
      </div>
    </v-progress-circular>
	</v-overlay>-->
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  import WHeader from './components/WHeader.vue'
  import WSystemStatusBar from './components/WSystemStatusBar.vue'
  import Constants from '@/helpers/Constants'
  import EventBus from '@/utils/EventBus'
  import type GuiMessage from '@/types/GuiMessage'
  // import MessageStatus from '@/types/MessageStatus'
  import PB from '@/brokers/PersistencyBroker'
  import store from '@/store'
  // import MessageDialog from './components/common/MessageDialog.vue'

  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  export default defineComponent({
    components: {
      WHeader,
      WSystemStatusBar,
      // MessageDialog,
    },

    data() {
      return {
        // MESSAGE_STATUS: MessageStatus,
        theme: 'Dark',
        toastPosition: 'bottom-center',
        // CONSTANTS: Constants,
        message: {} as GuiMessage,
        showMessage: false,
        showMessageDialog: false,
        loadingControls: {
          show: false,
          indeterminate: true,
          value: 0,
        },
      }
    },

    computed: {
      isLoggedIn(): boolean {
        return store.getters.isLoggedIn
      },
      // Hide nav + status bar during forced first-login password change so
      // heartbeat polling cannot spam "Password change required" toasts or
      // sound subsystem alarms before the user can finish the reset.
      showChrome(): boolean {
        return this.isLoggedIn && !store.getters.getMustChangePassword
      },
    },

    created() {
      // Set page title with app title
      // document.title = env..VITE_APP_TITLE

      // Register an event listener for the global messages
      //@ts-ignore - Vite sucks
      EventBus.on(Constants.EVENTS.SHOW_MESSAGE, this.showGuiMessage)
      //@ts-ignore - Vite sucks
      EventBus.on(Constants.EVENTS.SHOW_MESSAGE_DIALOG, this.showGuiMessageDialog)
      //@ts-ignore - Vite sucks
      EventBus.on(Constants.EVENTS.SHOW_LOADING, this.showLoadingOverlay)
      //@ts-ignore - Vite sucks
      EventBus.on(Constants.EVENTS.SET_TOAST_POSITION, this.setToastPosition)
      //@ts-ignore - Vite sucks
      EventBus.on(Constants.EVENTS.THEME_CHANGED, this.changeTheme)

      // Sync settings
      // Sync toast position
      const position = PB.get(Constants.LOCAL_STORAGE_IDS.TOAST_POSITION)
      if (position) {
        this.toastPosition = position
      }
      // Sync toast position
      const theme = PB.get(Constants.LOCAL_STORAGE_IDS.THEME)
      if (theme) {
        this.theme = theme
      }
      this.changeTheme(this.theme)

    },

    methods: {

      setToastPosition(position: string) {
        this.toastPosition = position
      },

      /**
       * Change between dark and light theme
       */
      changeTheme(theme: string) {
        let currentTheme = 'aura-light-blue'
        let nextTheme = 'aura-dark-teal'
        if (theme == 'Light') {
          currentTheme = 'aura-dark-teal'
          nextTheme = 'aura-light-blue'
        }
        this.$primevue.changeTheme(currentTheme, nextTheme, 'theme-link', () => {})
      },


      /**
       * Show/hide global message
       *
       * @param message message object of type GuiMessage
       */
      showGuiMessage(message: GuiMessage | boolean) {
        this.showMessage = false
        if (message == false)
          return
        this.message = message as GuiMessage
        this.showMessage = true
      },

      /**
       * Show/hide global message dialog
       *
       * @param message message object of type GuiMessage
       */
      // showGuiMessageDialog(message: GuiMessage | boolean) {
      //   this.showMessageDialog = false
      //   if (message == false)
      //     return
      //   this.message = message as GuiMessage
      //   this.showMessageDialog = true
      // },

      /**
       * Show/hide loading overlay
       *
       * @param show boolean (show/hide)
       */
      // showLoadingOverlay(val: boolean | number) {
      //   if (val == false) {
      //     // Close loading overlay
      //     this.loadingControls.value = 100
      //     setTimeout(() => {
      //       this.loadingControls.show = false
      //     }, 300)
      //   } else if (val == true) {
      //     // Show loading overlay - indetrminately
      //     this.loadingControls.indeterminate = true
      //     this.loadingControls.value = 0
      //     this.loadingControls.show = true
      //   } else {
      //     // Show loading overlay - with a step increase
      //     this.loadingControls.indeterminate = false
      //     this.loadingControls.value = val * 10
      //     this.loadingControls.show = true
      //   }
      // },

    }
  })
</script>

<style scoped>
.app-chrome {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: var(--surface-ground, #f8fafc);
  box-shadow: 0 1px 0 var(--surface-border, #e2e8f0);
}
</style>